import { sva, RecipeVariantProps } from "styled-system/css";

export const eventOperatorCardRecipe = sva({
  slots: ["surface", "body", "dateAndTitle", "hero"],
  base: {
    surface: {
      display: "grid",
      flexGrow: 1,
      flexShrink: 0,
      backgroundColor: "#FFF",
      borderRadius: "12px",
      gridTemplateAreas: "'cardBody' 'cardHero'",
      gridTemplateColumns: "auto 180px",
      minW: "360px",
      maxW: "540px",
      h: "180px",
      maxH: "180px",
      minH: "180px",
    },
    body: {
      p: "24px",
      justifyContent: "space-between",
      rowGap: "0",
      w: "full",
      gridArea: "cardBody",
    },
    dateAndTitle: {
      flexDir: "column",
      gap: "100",
    },
    hero: {
      display: "flex",
      alignItems: "center",
      // Super weird. In theory, there should be a gridArea here called cardHero,
      // but when it is added it breaks the grid in landscape mode. No idea why.
      w: "180px",
      maxW: "180px",
      minW: "180px",
      h: "180px",
      maxH: "180px",
      minH: "180px",
    },
  },
  variants: {
    borderStyle: {
      solid: {
        surface: {
          bgColor: "white",
        },
      },
      dashed: {
        surface: {
          borderStyle: "dashed",
          bgColor: "bg.wa.lightest",
        },
      },
    },
  },
  defaultVariants: {
    borderStyle: "solid",
  },
});

export type EventOperatorCardRecipeProps = RecipeVariantProps<
  typeof eventOperatorCardRecipe
>;
